
export enum LayerSourceType  {
  WMS ='WMS',
  WMTS = 'WMTS',
  NONE = 'NONE'
}